import { collectStore, INITIAL_STATE } from "./store";
import { type CollectState } from "./store.types";

function init(orderLines: string[]): void {
  collectStore.setState((state) => {
    const existing = state.orderLines;

    // We compute the intersection because when the order is re-fetched,
    // the server regenerates the orderLine IDs. This prevents keeping stale IDs
    // in the store that no longer exist in the current payload.
    const intersection = existing.filter((id) => orderLines.includes(id));

    if (intersection.length === 0) {
      // None of the passed orderLines are in the store: initialize with all
      return { orderLines };
    }

    // Some orderLines already exist: keep only those still valid
    return { orderLines: intersection };
  });
}

function toggleOrderLine(orderLineId: string): void {
  collectStore.setState((state) => {
    const orderLine = state.orderLines.find((line) => line === orderLineId);

    if (orderLine) {
      return {
        orderLines: state.orderLines.filter((line) => line !== orderLineId)
      };
    }

    return { orderLines: [...state.orderLines, orderLineId] };
  });
}

function setSuccessInfo(successInfo: CollectState["successInfo"]): void {
  collectStore.setState({ successInfo });
}

function setFlow(flow: CollectState["flow"]): void {
  collectStore.setState({ flow });
}

function reset(): void {
  collectStore.setState({
    orderLines: INITIAL_STATE.orderLines,
    successInfo: INITIAL_STATE.successInfo,
    flow: INITIAL_STATE.flow
  });
}

function setStatusFilter(statusFilter: CollectState["statusFilter"]): void {
  collectStore.setState({ statusFilter });
}

function setSearchBy(searchBy: CollectState["searchBy"]): void {
  collectStore.setState({ searchBy, selectedLetter: null });
}

function setSelectedLetter(
  selectedLetter: CollectState["selectedLetter"]
): void {
  collectStore.setState({ selectedLetter });
}

function setGroupPrimary(groupPrimary: CollectState["groupPrimary"]): void {
  collectStore.setState({ groupPrimary, groupSecondary: null });
}

function setGroupSecondary(
  groupSecondary: CollectState["groupSecondary"]
): void {
  collectStore.setState({ groupSecondary });
}

function resetGroupFilter(): void {
  collectStore.setState({ groupPrimary: null, groupSecondary: null });
}

function resetFilters(): void {
  collectStore.setState({
    statusFilter: INITIAL_STATE.statusFilter,
    searchBy: INITIAL_STATE.searchBy,
    selectedLetter: INITIAL_STATE.selectedLetter
  });
}

function resetAllFilters(): void {
  collectStore.setState({
    statusFilter: INITIAL_STATE.statusFilter,
    groupPrimary: INITIAL_STATE.groupPrimary,
    groupSecondary: INITIAL_STATE.groupSecondary,
    searchBy: INITIAL_STATE.searchBy,
    selectedLetter: INITIAL_STATE.selectedLetter
  });
}

export const collectActions = {
  init,
  toggleOrderLine,
  setSuccessInfo,
  setFlow,
  reset,
  setStatusFilter,
  setSearchBy,
  setSelectedLetter,
  setGroupPrimary,
  setGroupSecondary,
  resetGroupFilter,
  resetFilters,
  resetAllFilters
};
